// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__c9XC4","clinicsSelect":"TableHeading_clinicsSelect__3xLf6"};